// @flow
import * as React from "react";

function Footer(): React.Node {
  const year = new Date().getFullYear();

  return (
    <footer className="Footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 text-center">
            <p className="text-muted">&copy; {year} Vortex. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
